export { FavoriteNote } from './favorite-note';
